/* eslint-disable */
/* tslint:disable */
/* auto-generated react proxies */
import { createReactComponent } from './react-component-lib';

import type { JSX } from '@ovhcloud/ods-stencil/components/range/custom-elements';

import { defineCustomElement as defineOsdsRange } from '@ovhcloud/ods-stencil/components/range/custom-elements/osds-range.js';

export const OsdsRange = /*@__PURE__*/createReactComponent<JSX.OsdsRange, HTMLOsdsRangeElement>('osds-range', undefined, undefined, defineOsdsRange);
